import apiClient, { clearSharedGetCache, fetchCachedResource } from "./client";

export const fetchResourceList = async (endpoint, params = {}) => {
  const response = await apiClient.get(endpoint, { params });
  return response.data;
};

export const createResource = async (endpoint, payload) => {
  const response = await apiClient.post(endpoint, payload);
  clearSharedGetCache();
  return response.data;
};

export const uploadFormResource = async (endpoint, formData, shouldClearCache = false) => {
  const response = await apiClient.post(endpoint, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (shouldClearCache) {
    clearSharedGetCache();
  }
  return response.data;
};

export const downloadResource = async (endpoint, params = {}) => {
  const response = await apiClient.get(endpoint, { params, responseType: "blob" });
  const disposition = response.headers["content-disposition"] || "";
  const match = disposition.match(/filename="?([^";]+)"?/i);
  return {
    blob: response.data,
    filename: match?.[1] || "download.csv",
  };
};

export const updateResource = async (endpoint, id, payload, config = {}) => {
  const response = await apiClient.put(id ? `${endpoint}/${id}` : endpoint, payload, config);
  clearSharedGetCache();
  return response.data;
};

export const expectedVersionHeaders = (record) => (record?.updated_at ? { headers: { "X-Expected-Updated-At": record.updated_at } } : {});

export const patchResource = async (endpoint, id, payload) => {
  const response = await apiClient.patch(id ? `${endpoint}/${id}` : endpoint, payload);
  clearSharedGetCache();
  return response.data;
};

export const deleteResource = async (endpoint, id) => {
  const response = await apiClient.delete(`${endpoint}/${id}`);
  clearSharedGetCache();
  return response.data;
};

export const fetchResource = async (endpoint) => {
  const response = await apiClient.get(endpoint);
  return response.data;
};

export const fetchLoadById = async (loadId) => fetchCachedResource(`/loads/${loadId}`, {}, 60 * 1000);

export const fetchDispatchTripDetail = async (tripId) => fetchCachedResource(`/dispatch-board/${tripId}/detail`, {}, 60 * 1000);

export const fetchNextLoadNumber = async () => fetchResource("/loads/next-number");

export const fetchCustomerDetail = async (customerId) => {
  const response = await apiClient.get(`/customers/${customerId}/detail`);
  return response.data;
};